import { render, staticRenderFns } from "./TosEditFormVuetify.vue?vue&type=template&id=63bfcab4&scoped=true"
import script from "./TosEditFormVuetify.vue?vue&type=script&lang=js"
export * from "./TosEditFormVuetify.vue?vue&type=script&lang=js"
import style0 from "./TosEditFormVuetify.vue?vue&type=style&index=0&id=63bfcab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfcab4",
  null
  
)

export default component.exports